import type {SideNavClass} from "../homepage-data.ts";

const hasActiveAssignments = (
    classA: SideNavClass,
    classB: SideNavClass,
): number => {
    if (classA.hasActiveAssignments && !classB.hasActiveAssignments) {
        return -1;
    }

    if (!classA.hasActiveAssignments && classB.hasActiveAssignments) {
        return 1;
    }

    return 0;
};

const latestDueDate = (classA: SideNavClass, classB: SideNavClass): number => {
    // sort classes with earlier due dates first (earlier dates first)
    if (classA.latestDueDate && classB.latestDueDate) {
        if (classA.latestDueDate.isBefore(classB.latestDueDate)) {
            return -1;
        }

        if (classA.latestDueDate.isAfter(classB.latestDueDate)) {
            return 1;
        }

        return 0;
    }

    if (classA.latestDueDate && !classB.latestDueDate) {
        return -1;
    }

    if (!classA.latestDueDate && classB.latestDueDate) {
        return 1;
    }

    return 0;
};

const createdOn = (classA: SideNavClass, classB: SideNavClass): number => {
    // sort more recently created first (later dates first)
    if (classA.createdOn && classB.createdOn) {
        if (classA.createdOn.isAfter(classB.createdOn)) {
            return -1;
        }

        if (classA.createdOn.isBefore(classB.createdOn)) {
            return 1;
        }

        return 0;
    }

    if (classA.createdOn && !classB.createdOn) {
        return -1;
    }

    if (!classA.createdOn && classB.createdOn) {
        return 1;
    }

    return 0;
};

export const byClassActiveness = (
    classA: SideNavClass,
    classB: SideNavClass,
): number => {
    return (
        hasActiveAssignments(classA, classB) ||
        latestDueDate(classA, classB) ||
        createdOn(classA, classB)
    );
};

export default {};
